// Chakra Icons
import { BellIcon } from "@chakra-ui/icons";
// Chakra Imports
import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
// Custom Icons
import {
  ArgonLogoDark,
  ArgonLogoLight,
  ChakraLogoDark,
  ChakraLogoLight,
  ProfileIcon,
  SettingsIcon,
  SWDLogo,
} from "components/Icons/Icons";
// Custom Components
import { ItemContent } from "components/Menu/ItemContent";
import { SearchBar } from "components/Navbars/SearchBar/SearchBar";
import { SidebarResponsive } from "components/Sidebar/Sidebar";
import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import routes from "routes.js";
import { Avatar, AvatarBadge, AvatarGroup } from "@chakra-ui/react";
import { useMediaQuery } from "react-responsive";
import {
  FaBell,
  FaSun,
  FaMoon,
  FaPaperclip,
  FaCarCrash,
  FaNewspaper,
  FaRegNewspaper,
  FaScroll,
  FaReceipt,
  FaFileSignature,
  FaBriefcase,
} from "react-icons/fa";
import axios from "axios";
import apiUrl from "variables/api";
import io from "socket.io-client";
import { toast } from "react-toastify";

export default function HeaderLinks(props) {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const {
    variant,
    children,
    fixed,
    scrolled,
    secondary,
    onOpen,
    ...rest
  } = props;

  const { colorMode, toggleColorMode, setColorMode } = useColorMode();
  const [notifications, setNotifications] = useState([]);
  const socketRef = useRef(null); // Przechowujemy instancję WebSocketu

  const connectWebSocket = () => {
    const userId = localStorage.getItem("id");
    if (!userId) return; // Upewniamy się, że mamy ID użytkownika

    if (socketRef.current) {
      console.log("Zamykam istniejący WebSocket...");
      socketRef.current.close(); // Zamykamy istniejące połączenie przed otwarciem nowego
    }

    console.log("Łączę WebSocket...");
    const newSocket = new WebSocket(`wss://api.safd.top?userId=${userId}`);
    
    newSocket.onopen = () => {
      console.log("✅ WebSocket połączony");
    };

    newSocket.onmessage = (event) => {
      try {
        const payload = JSON.parse(event.data);
        console.log("📩 Otrzymano wiadomość:", payload);

        if (payload.event === "notifications-init") {
          setNotifications(payload.data);
        }
        if (payload.event === "notifications-new") {
          setNotifications((prev) => [...prev, payload.data]);
          toast("🔔 Otrzymano nowe powiadomienie!");
        }
      } catch (error) {
        console.error("❌ Błąd parsowania wiadomości:", error);
      }
    };

    newSocket.onerror = (error) => {
      console.error("❌ Błąd WebSocket:", error);
    };

    newSocket.onclose = (event) => {
      console.warn("⚠ WebSocket zamknięty:", event.reason);
      
      if (event.code === 1006 || event.code === 1011) {
        console.log("♻ Ponowne łączenie z WebSocket za 2,5s...");
        setTimeout(connectWebSocket, 2500);
      }
    };

    socketRef.current = newSocket; // Zapisujemy referencję do WebSocketu
  };

  useEffect(() => {
    connectWebSocket();

    return () => {
      if (socketRef.current) {
        console.log("♻ Zamykam WebSocket przy odmontowaniu komponentu...");
        socketRef.current.close();
      }
    };
  }, []);

  useEffect(() => {
    axios
      .get(apiUrl + "/data/dark", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.mode == "light") {
          setColorMode("light");
          enforceLightMode();
        }
      })
      .catch((error) => {
        console.error("Error fetching dark mode data:", error);
      });
  }, [colorMode, setColorMode]);

  const changeColorMode = () => {
    axios
      .get(apiUrl + "/data/dark", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.mode == "light") {
          setColorMode("light");
          enforceLightMode();
        } else {
          toggleColorMode();
        }
      })
      .catch((error) => {
        console.error("Error fetching dark mode data:", error);
        toggleColorMode();
      });
  };

  const enforceLightMode = () => {
    document.body.style.backgroundColor = "#ffffff !important";
    document.body.style.color = "#000000 !important";
  };

  // Chakra Color Mode
  let navbarIcon = useColorModeValue("gray.700", "gray.200");
  let menuBg = useColorModeValue("white", "gray.800");
  if (secondary) {
    navbarIcon = "white";
  }

  const [avatar, setAvatar] = useState(false);
  const [nickname, setNickname] = useState(false);

  useEffect(() => {
    setAvatar(localStorage.getItem("avatar"));
    setNickname(localStorage.getItem("nickname"));
  }, []);

  const markNotificationsAsRead = () => {
    if(!notifications.some((notification) => notification.readed == 0)) return;
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      socketRef.current.send(
        JSON.stringify({
          event: "notifications-read"
        })
      );
    } else {
      console.error("WebSocket is not open. Cannot send message.");
    }
  };

  const menuListRef = useRef(null);

  const handleMenuOpen = () => {
  setTimeout(() => {
    if (menuListRef.current) {
      console.log("Przewijam do góry");
      menuListRef.current.scrollTop = 0
    }
  }, 10);
  };

  return (
    <Flex
      pe={{ sm: "0px", md: "16px" }}
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      gap={3}
    >
      <NavLink to="#">
        <Button
          ms="0px"
          px="0px"
          me={{ sm: "2px", md: "16px" }}
          color={navbarIcon}
          variant="no-effects"
          leftIcon={<Avatar size="xs" name={nickname} src={avatar} />}
        >
          {!isMobile && (
            <Text display={{ sm: "none", md: "flex" }}>{nickname}</Text>
          )}
        </Button>
      </NavLink>
      <SidebarResponsive
        hamburgerColor={colorMode === "light" ? "black" : "white"}
        logo={
          <Stack direction="row" align="center" justify="center">
            <SWDLogo w="100px" h="100px" />
          </Stack>
        }
        colorMode={colorMode}
        secondary={props.secondary}
        routes={routes}
        {...rest}
      />
      {/* <SettingsIcon
        cursor='pointer'
        ms={{ base: "16px", xl: "0px" }}
        me='16px'
        onClick={props.onOpen}
        color={navbarIcon}
        w='18px'
        h='18px'
      /> */}
      <Box onClick={changeColorMode} cursor={"pointer"}>
        {colorMode === "light" ? (
          <FaMoon color={navbarIcon} />
        ) : (
          <FaSun color={navbarIcon} />
        )}
      </Box>
      <Menu onClose={markNotificationsAsRead} onOpen={handleMenuOpen}>
        <MenuButton position="relative" cursor="pointer">
          <FaBell color={navbarIcon} w="18px" h="18px" />
          {notifications.some((notification) => notification.readed == 0) && (
            <Box
              position="absolute"
              top="-3px"
              right="-3px"
              w="8px"
              h="8px"
              bg="red.500"
              borderRadius="50%"
            />
          )}
        </MenuButton>
        <MenuList ref={menuListRef} p="16px 8px" bg={menuBg} maxHeight={{ sm: "calc(100vh - 100px)", md: "400px" }} overflowY="auto">
          <Flex
            flexDirection="column-reverse"
            justifyContent={"center"}
            alignItems={"center"}
          >
            {notifications.map((notification, index) => (
              <MenuItem borderRadius="8px" mb="10px" key={index}>
                <ItemContent
                  time={notification.time}
                  info={notification.info}
                  type={notification.type}
                  link={notification.link}
                  readed={notification.readed}
                />
              </MenuItem>
            ))}
            {notifications.length === 0 && (
              <Text fontSize="14px" color={navbarIcon}>
                Brak powiadomień
              </Text>
            )}
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}
